import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';

const membersKey = (entityId) => ['admin', 'entities', entityId, 'members'];

export function useEntityMembers(entityId) {
  return useQuery({
    queryKey: membersKey(entityId),
    queryFn: () => api.get(`/admin/entities/${entityId}/members`),
    staleTime: 30_000,
    enabled: Boolean(entityId),
  });
}

// Mutations invalidate the members list *and* ['me'] — member_count is
// carried on every membership row returned by /auth/me, so sharing/revoking
// access must refresh both to keep the private/shared badge and the group
// scope eligibility (EntitySelector, Sidebar) accurate everywhere at once.
function useMembersMutation(entityId, mutateFn) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: mutateFn,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: membersKey(entityId) });
      qc.invalidateQueries({ queryKey: ['me'] });
    },
  });
}

export function useAddMember(entityId) {
  return useMembersMutation(entityId, (userId) =>
    api.post(`/admin/entities/${entityId}/members`, { user_id: userId })
  );
}

export function useRemoveMember(entityId) {
  return useMembersMutation(entityId, (userId) =>
    api.delete(`/admin/entities/${entityId}/members/${userId}`)
  );
}
